import { request } from './api';
import * as Alert from './alert';
/**
 * Action constants
 */
export const HOLDINGS_CONCENTRATION_REQUEST = 'HOLDINGS_CONCENTRATION_REQUEST';
export const HOLDINGS_CONCENTRATION_FETCH_SUCCESS =
  'HOLDINGS_CONCENTRATION_FETCH_SUCCESS';
export const HOLDINGS_CONCENTRATION_FETCH_FAIL =
  'HOLDINGS_CONCENTRATION_FETCH_FAIL';
export const HOLDINGS_CONCENTRATION_CLEAR = 'HOLDINGS_CONCENTRATION_CLEAR';
export const HOLDINGS_CONCENTRATION_SET_SELECTED_ACCOUNTS =
  'HOLDINGS_CONCENTRATION_SET_SELECTED_ACCOUNTS';
// return dispatch(request('get', `/security/${id}/`))
/**
 * Action creators
 */
export function fetch(accounts) {
  return (dispatch) => {
    dispatch({ type: HOLDINGS_CONCENTRATION_REQUEST });

    return dispatch(
      request('post', `/accounts/holdings/concentration/`, {
        body: { accounts },
      })
    ).then(
      (data) => {
        dispatch({
          type: HOLDINGS_CONCENTRATION_FETCH_SUCCESS,
          holdings: data,
          accounts,
        });
        return data;
      },
      (error) => {
        dispatch({
          type: HOLDINGS_CONCENTRATION_FETCH_FAIL,
        });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function clear() {
  return (dispatch) => {
    dispatch({ type: HOLDINGS_CONCENTRATION_REQUEST });

    dispatch({
      type: HOLDINGS_CONCENTRATION_CLEAR,
    });
  };
}

export function setSelectedAccounts(accountIds) {
  return {
    type: HOLDINGS_CONCENTRATION_SET_SELECTED_ACCOUNTS,
    accounts: accountIds,
  };
}

/**
 * Helper Functions
 */
function parseErr(err) {
  if (err.non_field_errors) {
    return err.non_field_errors[0];
  }

  return err.msg || err.detail || 'Failed to get holdings concentration.';
}
